var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"boutons"},[_c('simple-bouton',{attrs:{"text":"Activités","destination":"/Eleve/Activite"}}),_c('simple-bouton',{attrs:{"text":"Notes","destination":"/Eleve/Notes"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }